export function setReporteMarketing(state, reporteMarketing) {
    state.reporteMarketing = reporteMarketing;
}

export function setReporteMarketingAgencia(state, reporteMarketingAgencia) {
    state.reporteMarketingAgencia = reporteMarketingAgencia;
}

export function setReporteMarketingAgenciaPorCamino(state, reporteMarketingAgenciaPorCamino) {
    state.reporteMarketingAgenciaPorCamino = reporteMarketingAgenciaPorCamino;
}

export function setReportePasajerosProcedencia(state, reportePasajerosProcedencia) {
    state.reportePasajerosProcedencia = reportePasajerosProcedencia;
}

export function setReporteAsignacionesPorTrabajador(state, reporteAsignacionesPorTrabajador) {
    state.reporteAsignacionesPorTrabajador = reporteAsignacionesPorTrabajador;
}

export function setReporteReservasAsignadasTrabajador(state, reporteReservasAsignadasTrabajador) {
    state.reporteReservasAsignadasTrabajador = reporteReservasAsignadasTrabajador;
}
